import React from 'react';
const NameCompany = () => {
    return {
        display: "Apoyo Financiero",
        legalName: "Apoyo Financiero, Inc.",
        slogan: <strong>El préstamo fácil  <br />sin salir de casa</strong>
    }    
    
}

export default NameCompany